/* eslint-disable react/prop-types */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classNames from 'classnames';
import { InternalLink } from './internalLink';
export const IconLink = ({ iconClassName, accEnabled, href, className, onClick, title, children })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "icon-link",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames(iconClassName, 'icon')
            }),
            /*#__PURE__*/ _jsx(InternalLink, {
                accEnabled: accEnabled,
                href: href,
                role: "link",
                className: className,
                onClick: onClick,
                title: title,
                children: children
            })
        ]
    });
};
